import { HttpClient } from "./HttpClient";
import { GET_CATEGORIES, GET_CHANNELS, GET_COVERAGE_TYPES, GET_PAQUETES, GET_FRANJAS, GET_PLANS } from "../constants/endPoints"

export class CategoriesService {
    constructor(http = HttpClient) {
        this.http = http
    }

    async getCategoriesItems() {
        const { data } = await this.http.post(GET_CATEGORIES)
        return data
    }
}

export class ChannelsService {
    constructor(http = HttpClient) {
        this.http = http
    }

    async getChannelsItems() {
        const { data } = await this.http.post(GET_CHANNELS)
        return data
    }
}

export class CoverageTypeService {
    constructor(http = HttpClient) {
        this.http = http
    }

    async getCoverageTypeItems() {
        const { data } = await this.http.post(GET_COVERAGE_TYPES)
        return data
    }
}

export class PaqueteService {
    constructor(http = HttpClient) {
        this.http = http
    }

    async getPaqueteItems() {
        const { data } = await this.http.post(GET_PAQUETES)
        return data
    }
}

export class FranjaService {
    constructor(http = HttpClient) {
        this.http = http
    }

    async getFranjaItems(idCat) {
        const { data } = await this.http.post(`${GET_FRANJAS}?fi_categoria=${idCat}`)
        return data
    }
}

export class PlanService {
    constructor(http = HttpClient) {
        this.http = http
    }

    async getPlanesItems() {
        const { data } = await this.http.post(GET_PLANS)
        return data
    }
}